<div class="card-table-details">
  <nf-table-layout
    hideTitle
    *nfLoader="loading"
    hideSearch
    [autoResizeGrid]="false"
    [isSectionTitle]="false"
    [gridOptions]="gridOptionsSleeveDetails"
    [data]="sleeveDetailsData"
    hideClearAll
  >
  </nf-table-layout>
</div>
